module.exports = __webpack_public_path__ + "media/images/emblems/Gemeindewappen_Konolfingen-9cb6178568ca5e256c94f21ce6a70ee7.png";